import React, { useEffect, useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import Background1 from "../../assets/images/breadcum/01.jpg";

export default function InnerGallary() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [galleryData, setGalleryData] = useState([]);
  const [eventTitle, setEventTitle] = useState("");
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [images, setImages] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  const slugify = (text) => {
    return text
      .toString()
      .toLowerCase()
      .trim()
      .replace(/\s+/g, "-")
      .replace(/[^\w\-]+/g, "")
      .replace(/\-\-+/g, "-");
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Step 1: Get all gallery items to find the ID matching the slug
        const resAll = await axios.get(
          `${process.env.REACT_APP_BASE_API_URL}/api/auth/AllGalleryMaster`
        );

        const galleryItem = resAll.data.find(
          (item) => slugify(item.Title.Title) === slug
        );

        if (galleryItem) {
          setEventTitle(galleryItem.Title.Title);
          const id = galleryItem.Title._id;
          // Step 2: Fetch specific gallery details using the ID
          const res = await axios.get(
            `${process.env.REACT_APP_BASE_API_URL}/api/auth/AllGalleryMasterById/${id}`
          );
          setGalleryData(res.data.data);
        } else {
          // Redirect to home if slug not found
          navigate("/", { replace: true });
        }

      } catch (error) {
        console.error(error);
        navigate("/", { replace: true });
      }
    };
    if (slug) {
      fetchData();
    }
  }, [slug, navigate]);

  // useEffect(() => {
  //   if (!lightboxOpen) return;

  //   const handleKeyPress = (e) => {
  //     if (e.key === "ArrowRight") {
  //       nextImage();
  //     } else if (e.key === "ArrowLeft") {
  //       prevImage();
  //     } else if (e.key === "Escape") {
  //       closeLightbox();
  //     }
  //   };

  //   window.addEventListener("keydown", handleKeyPress);

  //   return () => {
  //     window.removeEventListener("keydown", handleKeyPress);
  //   };
  // }, [lightboxOpen]);


  useEffect(() => {
    document.body.style.overflow = lightboxOpen ? "hidden" : "auto";
  }, [lightboxOpen]);

  const openLightbox = (allImages, index) => {
    setImages(allImages);
    setCurrentIndex(index);
    setLightboxOpen(true);
  };

  const closeLightbox = () => setLightboxOpen(false);

  const nextImage = () =>
    setCurrentIndex((prev) => (prev + 1) % images.length);

  const prevImage = () =>
    setCurrentIndex((prev) =>
      prev === 0 ? images.length - 1 : prev - 1
    );

  return (
    <>
      {/* ===== HEADER ===== */}
      <section
        className="inner-banner bg-overlay-black-70 bg-holder"
        style={{ backgroundImage: `url(${Background1})` }}
      >
        <div className="container text-center" style={{ position: "relative", zIndex: 1 }}>
          <h1 className="text-white">{eventTitle}</h1>
          <ol className="breadcrumb justify-content-center">
            <li className="breadcrumb-item">
              <Link to="/">Home</Link>
            </li>
            <li className="breadcrumb-item">
              <Link to="/photo-gallery">Photo Gallery</Link>
            </li>
            <li className="breadcrumb-item active">{eventTitle}</li>
          </ol>
        </div>
      </section>

      {/* ===== GALLERY GRID ===== */}
      <section className="space-ptb">
        <div className="container">
          <div className="row">
            {galleryData.map((item) =>
              item.File.map((img, index) => (
                <div
                  className="col-lg-4 col-sm-6 mt-4"
                  key={`${item._id}-${index}`}
                >
                  <div
                    className="portfolio-item"
                    onClick={() => openLightbox(item.File, index)}
                  >
                    <img
                      src={`${process.env.REACT_APP_BASE_API_URL}/${img}`}
                      alt="Gallery"
                    />
                    <div className="portfolio-overlay">
                      <div className="portfolio-img">
                        <i className="fa fa-arrows-alt"></i>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </section>

      {/* ===== LIGHTBOX ===== */}
      {lightboxOpen && (
        <div className="gallery-lightbox">
          <span className="close-btn" onClick={closeLightbox}>
            &times;
          </span>

          <span className="nav prev" onClick={prevImage}>
            &#10094;
          </span>

          <img
            src={`${process.env.REACT_APP_BASE_API_URL}/${images[currentIndex]}`}
            alt="Preview"
          />

          <span className="nav next" onClick={nextImage}>
            &#10095;
          </span>
        </div>
      )}
    </>
  );
}
